/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Rate_PeriodsInputs */

const fr_validation_rate_periods = /** @type {(inputs: Validation_Rate_PeriodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez des périodes de TJM valides et sans chevauchement.`)
};

const en_validation_rate_periods = /** @type {(inputs: Validation_Rate_PeriodsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add valid, non-overlapping rate periods.`)
};

/**
* | output |
* | --- |
* | "Add valid, non-overlapping rate periods." |
*
* @param {Validation_Rate_PeriodsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_rate_periods = /** @type {((inputs?: Validation_Rate_PeriodsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Rate_PeriodsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_rate_periods(inputs)
	return fr_validation_rate_periods(inputs)
});